var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"charts",class:{bgColorEcharts:!!_vm.serData.length},style:({'height':_vm.chartHeight +'px'})},[(_vm.serData.length)?_c('v-chart',{ref:"chart",attrs:{"options":_vm.options,"autoresize":"","id":"chart_line"}}):_c('div',{staticClass:"nodata"},[_vm._v("No data was found")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }